export enum CompanyTypeEnum {
  'legal' = 'legal',
  'private' = 'private',
}

export enum CompanyFormattedTypeEnum {
  'legal' = 'Pessoa jurídica',
  'private' = 'Pessoa fisíca',
}
